// extracted by mini-css-extract-plugin
export default {"success":"Security_success__45iVs"};